import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=06baeb18&scoped=true&"
import script from "./AddSchool.vue?vue&type=script&lang=js&"
export * from "./AddSchool.vue?vue&type=script&lang=js&"
import style0 from "./AddSchool.vue?vue&type=style&index=0&id=06baeb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06baeb18",
  null
  
)

export default component.exports